import axios from "axios";

export const TIMETABLE_URL = "/Timetable";

// Mevcut Okulun Mevcut Eğitim Yılı ve İlk Dönemindeki Ders Programını Elde Eder
export function getCurrentTimetable() {
  return axios.get(TIMETABLE_URL);
}

// Mevcut Okulun Ders ve Öğretmen Listesini Elde Eder
export function getCoursesAndTeachers() {
  return axios.get(`${TIMETABLE_URL}/GetCoursesAndTeachers`);
}

// Mevcut Okulun Mevcut Eğitim Dönemindeki Ders, Sınıf ve Öğretmen Listesini Elde Eder
export function getList() {
  return axios.get(`${TIMETABLE_URL}/GetList`);
}

// Mevcut Okulun Belli Bir Eğitim Yılı ve Dönemindeki Ders Programını Elde Eder
export function getAllTimetable(term, semester) {
  return axios.get(`${TIMETABLE_URL}/GetAllTimetable/${term}/${semester}`);
}

// Mevcut Okulun Belli Bir Eğitim Yılının Belli Bir Dönemindeki Öğretmen Listesi ve
// Belli Bir Sınıfa veya Öğretmene Ait Ders Programını Elde Eder
export function getTeachersAndTimetable(tableType, term, semester, tableId) {
  return axios.get(`${TIMETABLE_URL}/GetTeachersAndTimetable/${tableType}/${term}/${semester}/${tableId}`);
}

// Mevcut Okulun Belli Bir Eğitim Yılının Belli Bir Dönemindeki Belli Bir Sınıfa veya Öğretmene Ait Ders Programını Elde Eder
export function getTimetable(tableType, term, semester, tableId) {
  return axios.get(`${TIMETABLE_URL}/GetTimetable/${tableType}/${term}/${semester}/${tableId}`);
}

// Mevcut Okulun Tüm Ders Programını Kaydeder
export function saveAllTimetable(timetable) {
  return axios.post(`${TIMETABLE_URL}/SaveAll`, timetable);
}

// Mevcut Okulun Belli Bir Sınıf veya Öğretmenine Ait Ders Programını Kaydeder
export function saveTimetable(timetable) {
  return axios.post(TIMETABLE_URL, timetable);
}

// Mevcut Okulun Belli Bir Döneme Ait Ders Programını Başka Bir Döneme Aktarır
export function transferTimetable(timetable) {
  return axios.post(`${TIMETABLE_URL}/Transfer`, timetable);
}

// Mevcut Okulun Belli Bir Ders Programını Siler
export function deleteTimetable(timetable) {
  return axios.post(`${TIMETABLE_URL}/Delete`, timetable);
}